import Skeleton from 'react-loading-skeleton';

type FeatureCardPlaceholderSkeletonProps = {
  totalFeatureInfoItems: number;
};

const FeatureCardPlaceholderSkeleton: React.FC<
  FeatureCardPlaceholderSkeletonProps
> = ({ totalFeatureInfoItems = 0 }) => {
  return (
    <div className="flex flex-col gap-2 w-full h-full">
      <div className="grow flex flex-col xl:flex-row gap-2 border-solid border-gray-mercury rounded-30">
        <div className="flex-1">
          <Skeleton className="w-full h-full mb-1 rounded-18" />
        </div>
        <div className="flex-1 flex flex-col gap-2">
          <div className="flex-1">
            <Skeleton className="w-full h-full mb-1 rounded-18" />
          </div>
          <div className="flex-1">
            <Skeleton className="w-full  h-full mb-1 rounded-18" />
          </div>
        </div>
      </div>
      {Array.from(Array(totalFeatureInfoItems).keys()).map((_, index) => {
        return (
          <div className="grow max-h-[4.5rem]" key={`skeleton-${index}`}>
            <Skeleton className="w-full h-full mb-1 rounded-18" />
          </div>
        );
      })}
    </div>
  );
};

export default FeatureCardPlaceholderSkeleton;
